import CashDepositDrop from 'src/models/cash/CashDepositDrop'
import Model, { encoders, ID, IsoDate, IsoDateTime } from 'src/models/model'
import User from 'src/models/user/User'

export default class CashDeposit extends Model {
  static name = 'CashDeposit'

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.PointOfSale, Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      id: {
        type: ID
      },

      date: {
        type: IsoDate,
        output: true
      },

      user: {
        type: User,
        output: true
      },
      note: {
        type: String
      },
      cashDepositDrops: {
        type: [CashDepositDrop],
        acceptsNestedAttributes: true
      },
      netSales: {
        type: Number,
        encode: encoders.cents,
        output: true,
        default: 0
      },
      totalCount: {
        type: Number,
        encode: encoders.cents,
        output: true,
        default: 0
      },

      closedAt: {
        type: IsoDateTime,
        output: true
      },
      action: {
        type: String,
        input: true
      }
    }

    this.computed = {
      amount () {
        return _.sumBy(this.cashDepositDrops.data, 'amount')
      },
      displayUser () {
        if (this.isLocal || this.status === 'Open') {
          return this.context?.currentUser
        } else {
          return this.user
        }
      },
      isClosed () {
        return !!this.closedAt
      },
      isOpen () {
        return !this.isClosed
      },
      status () {
        return this.isClosed ? 'Closed' : 'Open'
      },
      overUnder () {
        return this.totalCount - this.netSales
      },
      statusChip () {
        if (this.status === 'Open') {
          return {
            label: 'Open',
            textColor: 'white',
            color: 'positive',
            size: 'sm'
          }
        } else if (this.status === 'Closed') {
          return {
            label: 'Closed',
            textColor: 'white',
            color: 'negative',
            size: 'sm'
          }
        }

        return {
          label: 'Unknown',
          textColor: 'black',
          color: 'info',
          size: 'sm'
        }
      }
    }
  }

  async close () {
    this.action = 'close'
    await this.save()
    this.resetField('action')
  }

  async reopen () {
    this.action = 'reopen'
    await this.save()
    this.resetField('action')
  }
}
